<div class="resetPassForm-container">
  <form (ngSubmit)="onSubmit()" [formGroup]="fgroup" class="resetPassForm">
    <div class="currPassword-container">
      <div class="input-outline"
        [ngClass]="{'invalid-p-inputtext': submitted && errorCode === errorCodes.PasswordMisMatch_400 }"
        *ngIf="pageName === pageNames.ResetPasswordPage">
        <span class="p-float-label">
          <input id="current-password" [type]="showCurrPw? 'text': 'password'" pInputText formControlName="currPassword"
            #current_password>
          <label for="current-password">{{'label.current.password' | translate}}</label>
        </span>
        <i [ngClass]="{'icon-eye-close': !showCurrPw, 'icon-eye-open': showCurrPw }"
          (click)="showCurrPw = !showCurrPw"></i>

        <i class="icon-times" *ngIf="current_password.value && current_password.value.length > 0"
          (click)="fgroup.get('currPassword')?.reset() "></i>

        <i class="icon-alert" *ngIf="submitted && errorCode === errorCodes.PasswordMisMatch_400"></i>
      </div>
      <div class="invalid-feeback" *ngIf="submitted && errorCode === errorCodes.PasswordMisMatch_400">
        {{ 'error.invalid.password' | translate }}
      </div>
    </div>

    <div class="new-password-container">
      <div class="input-outline">
        <span class="p-float-label">
          <input id="new-password" [type]="showNewPw? 'text': 'password'" pInputText formControlName="password"
            #newpasswordvalue>
          <label for="new-password">{{'label.new.password' | translate}}</label>
        </span>
        <i [ngClass]="{'icon-eye-close': !showNewPw, 'icon-eye-open': showNewPw }" (click)="showNewPw = !showNewPw"></i>

        <i class="icon-times" *ngIf="newpasswordvalue.value && newpasswordvalue.value.length > 0"
          (click)="fgroup.get('password')?.reset() "></i>
      </div>

      <div class="password-validation">
        <i class="icon-check-circle" [ngClass]="{'active': newpasswordvalue.value.length >= 8 }"></i>
        <h1>{{'desc.password.length.validation' | translate}}</h1>
      </div>
    </div>

    <div class="confirm-password-container">
      <div class="input-outline"
        [ngClass]="{'invalid-p-inputtext': submitted && f.confirmPassword.errors && f.confirmPassword.errors.mustMatch }">
        <span class="p-float-label">
          <input id="confirm-password" [type]="showConfirmPw? 'text': 'password'" pInputText
            formControlName="confirmPassword" #confirmpasswordvalue>
          <label for="confirm-password">{{'label.confirm.password' | translate}}</label>
        </span>
        <i [ngClass]="{'icon-eye-close': !showConfirmPw, 'icon-eye-open': showConfirmPw }"
          (click)="showConfirmPw = !showConfirmPw"></i>

        <i class="icon-times" *ngIf="confirmpasswordvalue.value && confirmpasswordvalue.value.length > 0"
          (click)="fgroup.get('confirmPassword')?.reset() "></i>

        <i class="icon-alert" *ngIf="submitted && f.confirmPassword.errors && f.confirmPassword.errors.mustMatch"></i>
      </div>

      <div class="password-validation">
        <i class="icon-check-circle" [ngClass]="{'active': confirmpasswordvalue.value.length >= 8 }"></i>
        <h1>{{'desc.password.length.validation' | translate}}</h1>
      </div>

      <div class="invalid-feeback error-password-not-match" *ngIf="submitted && f.confirmPassword.errors && f.confirmPassword.errors.mustMatch">
        {{ 'error.password.not.match' | translate }}
      </div>
    </div>

    <app-button [buttonName]="pageName === pageNames.ForgotPasswordPage? ('button.reset') : ('button.change')"
      (onClickEvent)="onSubmit()"
      [disabled]="newpasswordvalue.value.length == 0 && confirmpasswordvalue.value.length === 0"></app-button>
  </form>
</div>
